import React, { useMemo } from 'react'
import Checkbox from '~/app/components/common/Checkbox/YaComCheckbox'
import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'

/**
 * CartItemSelector component
 * author: jaegeunlee
 * description
 */
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4.8rem;
  padding: 0 20px;
  background-color: ${({ theme }) => theme.color.white};
  ${Typography('body2').regular};
  max-width: ${({ theme }) => theme.unit.PC_WIDTH}px;
  width: 100%;
  margin: 0 auto;
`
const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  height: 2rem;

  label {
    height: 100%;
  }
`
const SelectAllCheckBox = styled(Checkbox)`
  > img {
    width: 2rem;
    height: 2rem;
  }
`
const SelectText = styled.div`
  margin-left: 0.8rem;
  color: ${({ theme }) => theme.color.gray900};
`
const RemoveContainer = styled.div`
  display: flex;
  align-items: center;
`

const RemoveText = styled.div<{ disable?: boolean }>`
  margin-left: 1.6rem;
  color: ${({ theme, disable }) => (disable ? theme.color.gray400 : theme.color.blue600)};
  cursor: pointer;
  padding: 0.8rem 0;

  :hover {
    background-color: ${({ theme, disable }) =>
      !disable && `${theme.color.blue600}09`}; // yaBlue with opacity 5%
  }
  :active {
    background-color: ${({ theme, disable }) =>
      !disable && `${theme.color.blue600}19`}; // yaBlue with opacity 10%
  }
`

interface CartItemSelectorProps {
  onCheck: (checked: boolean) => void
  onRemove: () => void
  onRemoveUnavailable: () => void
  currentCount: {
    checked: number
    availableChecked: number
    availableTotal: number
    total: number
  }
  count: {
    availableChecked: number
    total: number
  }
}
const CartItemSelector: React.FC<CartItemSelectorProps> = ({
  onCheck,
  onRemove,
  onRemoveUnavailable,
  currentCount,
  count,
}) => {
  const isCheckedRemoveBtnDisable = useMemo(() => {
    return currentCount.availableChecked <= 0
  }, [currentCount.availableChecked])

  const isUnavailableRemoveBtnDisable = useMemo(() => {
    return currentCount.total === currentCount.availableTotal
  }, [currentCount.total, currentCount.availableChecked])

  return (
    <Container>
      <SelectContainer>
        <SelectAllCheckBox
          onClick={() => onCheck(currentCount.checked !== currentCount.total)}
          checked={currentCount.checked === currentCount.total}
          disabled={currentCount.availableTotal <= 0}
        />
        <SelectText>
          전체 선택 ({count.availableChecked}/{count.total})
        </SelectText>
      </SelectContainer>
      <RemoveContainer>
        {!isUnavailableRemoveBtnDisable && (
          <RemoveText onClick={onRemoveUnavailable}>구매불가삭제</RemoveText>
        )}
        <RemoveText
          disable={isCheckedRemoveBtnDisable}
          onClick={() => !isCheckedRemoveBtnDisable && onRemove()}
          data-testid={'cart-remove-button'}
        >
          선택 삭제
        </RemoveText>
      </RemoveContainer>
    </Container>
  )
}

export default CartItemSelector
